import { render, staticRenderFns } from "./CardPremium.vue?vue&type=template&id=7c37b4c8&scoped=true&"
import script from "./CardPremium.vue?vue&type=script&lang=js&"
export * from "./CardPremium.vue?vue&type=script&lang=js&"
import style0 from "./CardPremium.vue?vue&type=style&index=0&id=7c37b4c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c37b4c8",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VImg})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c37b4c8')) {
      api.createRecord('7c37b4c8', component.options)
    } else {
      api.reload('7c37b4c8', component.options)
    }
    module.hot.accept("./CardPremium.vue?vue&type=template&id=7c37b4c8&scoped=true&", function () {
      api.rerender('7c37b4c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/SelecaoAssinatura/components/cards/acessor/CardPremium.vue"
export default component.exports